module.exports = __webpack_public_path__ + "static/media/hands.5fd05719.svg";